<template>
  <div
    class="grid"
    :style="`--columns:${columns}; --rows:${rows}; --width:${width}; --gap:${gap};`"
  >
    <slot></slot>
  </div>
</template>
<script type="text/javascript">
// import helper from './../helpers';

export default {
  name: "Grid",
  props: ["columns", "rows", "width", "gap"],
  data() {
    return {};
  },
};
</script>
<style scoped>
/*Defaults */
.grid {
  --width: 100%;
  --columns: 1;
  --rows: initial;
  --gap: 0;
}

.grid {
  width: var(--width);
  display: grid;
  grid-template-columns: repeat(var(--columns), 1fr);
  grid-template-rows: var(--rows);
  gap: var(--gap);
  /* height: 100%; */
}
</style>
